import { useTranslation } from "react-i18next";
import { Route, CircleDot } from "lucide-react";
import { RoutingAnimation } from "./RoutingAnimation";
import { RoutingTiers } from "./RoutingTiers";

export function RoutingSection() {
  const { t } = useTranslation();

  return (
    <section className="py-16 lg:py-28 bg-primary text-primary-foreground">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Header */}
        <h2 className="text-2xl lg:text-3xl font-heading font-semibold text-primary-foreground text-center mb-2">
          {t("productPages.atlas.routing.title")}
        </h2>
        <p className="text-primary-foreground/70 text-center mb-10 lg:mb-14 font-body max-w-2xl mx-auto">
          {t("productPages.atlas.routing.subtitle")}
        </p>

        {/* Two capabilities */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-10 mb-10 lg:mb-14 max-w-4xl mx-auto">
          <div className="flex gap-4">
            <div className="shrink-0 h-10 w-10 rounded-lg bg-white/10 flex items-center justify-center">
              <Route className="h-5 w-5 text-coral" />
            </div>
            <div>
              <h3 className="font-heading font-semibold text-primary-foreground mb-1">
                {t("productPages.atlas.routing.routes.title")}
              </h3>
              <p className="text-sm text-primary-foreground/70 font-body">
                {t("productPages.atlas.routing.routes.description")}
              </p>
            </div>
          </div>

          <div className="flex gap-4">
            <div className="shrink-0 h-10 w-10 rounded-lg bg-white/10 flex items-center justify-center">
              <CircleDot className="h-5 w-5 text-coral" />
            </div>
            <div>
              <h3 className="font-heading font-semibold text-primary-foreground mb-1">
                {t("productPages.atlas.routing.reach.title")}
              </h3>
              <p className="text-sm text-primary-foreground/70 font-body">
                {t("productPages.atlas.routing.reach.description")}
              </p>
            </div>
          </div>
        </div>

        {/* Animation */}
        <div className="max-w-3xl mx-auto">
          <RoutingAnimation />
        </div>

        {/* Tiers */}
        <RoutingTiers />
      </div>
    </section>
  );
}
